import type { Route } from './types';

export const defaultTitle = 'FASE2 Facility Service Köln – Objektpflege, Hausmeisterservice, Instandhaltung';
export const defaultDescription = 'FASE2 Facility Services in Köln und Umgebung: Objektpflege, Hausmeisterservice und Instandhaltung für Ihre Immobilie. Nehmen Sie Kontakt mit uns auf.';

export function applyRouteMetadata(meta: Route['meta']): void {
    document.title = meta?.title || defaultTitle;
    const descriptions = document.head.querySelectorAll<HTMLMetaElement>('meta[name="description"]');
    const description = descriptions[0] || document.createElement('meta');
    description.name = 'description';
    description.content = meta?.description || defaultDescription;
    if (!description.parentNode) document.head.appendChild(description);
    descriptions.forEach((element, index) => {
        if (index > 0) element.remove();
    });
}
